export default {
	color: 'slategrey',
	message: 'this is used by both entry points, so will be put in its own chunk'
};